import { ImageConvertStatus, isImageConvertStatusSuccess } from 'shared/domain/imageConvertStatus/imageConvertStatus';
import { isImageExtension } from 'shared/utils/fileExtensions';
import { EXTENSIONS } from 'shared/constants/EXTENSIONS';

const MAP_IMAGE_EXTENSIONS = new Set<string>(EXTENSIONS.MAP_IMAGE);

function isMapImageExtension(extension: string): boolean {
  const ext = extension?.toLowerCase();
  return Boolean(ext) && isImageExtension(ext) && MAP_IMAGE_EXTENSIONS.has(ext);
}

export function isSupportedAsMap(
  extension: string,
  imageConvertStatus: ImageConvertStatus | undefined
): boolean {
  return (
    isMapImageExtension(extension) ||
    (extension?.toLowerCase() === EXTENSIONS.PDF &&
      isImageConvertStatusSuccess(imageConvertStatus))
  );
}
